import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Input, Select, Icon } from 'antd';
import Coins from '../../components/Coins';
import { returnDate } from '../../common/utils';

const { Option } = Select;
const { Column } = Table;

export default class MyWallets extends Component {
	renderOptions = () => {
		const { coin } = this.props;
		const List = coin.map((item) => (
			<Option value={item.value} key={item.value}>
				{item.key}
			</Option>
		));
		return List;
	};

	render() {
		const {
			pagination,
			data,
			loading,
			name,
			currency,
			onSearch,
			onSelect,
			onChange,
			onKeyPress,
			onClick,
			handleTableChange,
			user,
		} = this.props;
		let title = '';
		if (user.verification_level === 4) {
			title = 'My Enterprise Wallets Page';
		} else if (user.verification_level === 3) {
			title = 'My Business Wallets Page';
		} else {
			title = 'My Lite Wallets Page';
		}
		return (
			<div className="wallet-list">
				<h2>
					<b>{title}</b>
				</h2>
				<div className="button-wrapper">
					<div className="filter-area">
						<Select value={currency} onChange={onSelect}>
							<Option value="">All</Option>
							{this.renderOptions()}
						</Select>
						<Input
							name="name"
							value={name}
							onChange={onChange}
							onKeyPress={onKeyPress}
							suffix={<Icon type="search" onClick={onSearch} />}
						/>
					</div>
					<Button type="primary" onClick={onClick}>
						Create Wallet
					</Button>
				</div>
				<div className="holla-table-wrapper">
					<Table
						// columns={TABLE_WALLET_COLUMN}
						dataSource={data}
						rowKey={(data) => {
							return data.id;
						}}
						loading={loading}
						pagination={pagination}
						onChange={handleTableChange}
					>
						<Column
							title="Name"
							dataIndex="name"
							key="name"
							width="20%"
							render={(name, row) => {
								const obj = {
									pathname: `/wallet/${name}`,
									state: { data: row },
								};
								return (
									<Link
										to={obj}
										style={{ textDecoration: 'underline' }}
									>
										{name}
									</Link>
								);
							}}
						/>
						<Column
							title="Asset"
							dataIndex="currency"
							width="20%"
							render={(d) => <Coins xs={true} type={d} />}
						/>
						<Column
							title="Created"
							dataIndex="created_at"
							width="20%"
							render={(d) => returnDate(d)}
						/>
						<Column
							title="Type"
							dataIndex="type"
							width="20%"
							render={(string) =>
								string.charAt(0).toUpperCase() + string.slice(1)
							}
						/>
						<Column
							title="Network"
							dataIndex="is_testnet"
							width="20%"
							render={(bool) =>
								bool ? (
									<span className="holla-label gray">Testnet</span>
								) : (
									<span className="holla-label green">Mainnet</span>
								)
							}
						/>
					</Table>
				</div>
			</div>
		);
	}
}
